import { createIcon } from '@chakra-ui/react';

export const AssignEmailIcon = createIcon({
  displayName: 'AssignEmailIcon',
  viewBox: '0 0 24 25',
  defaultProps: {
    fill: 'none',
    height: '24',
    width: '25',
  },
  path: (
    <path
      fill="currentColor"
      d="M17.5 12.5C20.5376 12.5 23 14.9624 23 18C23 21.0376 20.5376 23.5 17.5 23.5C14.4626 23.4998 12 21.0374 12 18C12 14.9626 14.4626 12.5002 17.5 12.5ZM16.75 17.25H13.6387V18.75H16.75V21.8613H18.25V18.75H21.3613V17.25H18.25V14.1387H16.75V17.25ZM9.5 10.25C11.3654 10.25 12.8436 10.9357 13.9736 11.8555L13.5 12.4365L13.0264 13.0186C12.1201 12.281 10.968 11.75 9.5 11.75C7.59628 11.7501 6.3009 12.6539 5.40723 13.752C4.70017 14.6209 4.25962 15.5978 4.00781 16.2969L10.9971 16.2705L11.0029 17.7705L3.46582 17.7998C2.76837 17.8021 2.1762 17.144 2.39746 16.3936L2.49512 16.0811C2.75991 15.2766 3.29238 13.9753 4.24414 12.8057C5.34704 11.4504 7.03737 10.2501 9.5 10.25ZM9.62891 2.75C11.7 2.75 13.3789 4.42893 13.3789 6.5C13.3789 8.57107 11.7 10.25 9.62891 10.25C7.55787 10.25 5.87891 8.57104 5.87891 6.5C5.87891 4.42896 7.55787 2.75004 9.62891 2.75ZM9.62891 4.25C8.3863 4.25004 7.37891 5.25738 7.37891 6.5C7.37891 7.74262 8.3863 8.74996 9.62891 8.75C10.8715 8.75 11.8789 7.74264 11.8789 6.5C11.8789 5.25736 10.8715 4.25 9.62891 4.25Z"
    />
  ),
});
